module.exports = __webpack_public_path__ + "static/media/26_B.6e1ace52.png";